export { LinkedInFill } from './linkedin'